module.exports = __webpack_public_path__ + "6b9d58530ecfbc53022e219351defa1e.jpg";